// extracted by mini-css-extract-plugin
export default {"cls1":"AdminBarActivator-cls1__ce1def872a62239cee36","cls2":"AdminBarActivator-cls2__ff82df62ca350e99b792 AdminBarActivator-cls1__ce1def872a62239cee36"};